module.exports = __webpack_public_path__ + "static/media/Illus-Pickup_2.8d5dc7e3.png";